import * as types from './types';

const initialState = {
  getContactValidationData: {},
  getContactValidationError: false,
  updatedUserPhones: [],
  hasInvalidFormatPhone: false,
  isUpdatedUserPhones: false,
  updateContactError: false,
  isLoading: false
};

function contactValidationReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_CONTACT_VALIDATION:
      return {
        ...state,
        getContactValidationError: false,
        isLoading: true
      };

    case types.GET_CONTACT_VALIDATION_COMPLETED:
      return {
        ...state,
        getContactValidationData: action.payload,
        isLoading: false
      };

    case types.GET_CONTACT_VALIDATION_FAILED:
      return {
        ...state,
        getContactValidationError: true,
        isLoading: false
      };

    case types.UPDATE_CONTACT_VALIDATION:
      return {
        ...state,
        isLoading: true,
        updateContactError: false,
        hasInvalidFormatPhone: true,
        isUpdatedUserPhones: false
      };

    case types.UPDATE_CONTACT_VALIDATION_COMPLETED:
      return {
        ...state,
        isLoading: false,
        updatedUserPhones: action.payload && action.payload.phones,
        hasInvalidFormatPhone: action.payload && action.payload.validationError,
        isUpdatedUserPhones: true
      };

    case types.UPDATE_CONTACT_VALIDATION_FAILED:
      return {
        ...state,
        isLoading: false,
        updateContactError: true,
        isUpdatedUserPhones: false
      };

    default:
      return state;
  }
}

export default contactValidationReducer;
